import { Icon } from '@cbhq/cds-web/icons/Icon';
import '../Div/index.js';
import { Text } from '../Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function ArrowText({
  children,
  variant = 'label2',
  hideIcon
}) {
  return /*#__PURE__*/jsxs(Div, {
    spacingTop: 3,
    alignItems: "center",
    css: {
      cursor: 'pointer',
      width: 'fit-content'
    },
    children: [/*#__PURE__*/jsx(Text, {
      variant: variant,
      as: "span",
      color: "primary",
      children: children
    }), !hideIcon && /*#__PURE__*/jsx(Icon, {
      spacingStart: 1,
      name: "forwardArrow",
      size: "xs"
    })]
  });
}
export { ArrowText };
//# sourceMappingURL=ArrowText.js.map
